/*
 * @Author: wangshengqiang
 * @Date: 2021-04-15 14:40:30
 * @LastEditTime: 2021-08-04 16:26:10
 * @LastEditors: wangshengqiang
 * @Description:
 */

/* eslint-disable eqeqeq */

/* eslint-disable no-restricted-syntax */
// eslint-disable-next-line import/prefer-default-export
let _queryParams = null;
let _lastSearch = '';
let _hashParam = null;
let _lastHash = '';

function parseParam(paramStr, delimiter) {
  const obj = {};

  if (paramStr) {
    const arr = paramStr.split(delimiter || '&');
    arr.length && arr.forEach(item => {
      const tempArr = item.split('=');
      obj[tempArr[0]] = decodeURIComponent(tempArr[1] || '');
    });
  }

  return obj;
}

export const delParam = (url, ref) => {
  let str = '';
  if (url.indexOf('?') != -1) str = url.substr(url.indexOf('?') + 1);else return url;
  let arr = '';
  let returnurl = '';

  if (str.indexOf('&') != -1) {
    arr = str.split('&');

    for (const i in arr) {
      if (arr[i].split('=')[0] != ref) {
        returnurl = `${returnurl + arr[i].split('=')[0]}=${arr[i].split('=')[1]}&`;
      }
    }

    return `${url.substr(0, url.indexOf('?'))}?${returnurl.substr(0, returnurl.length - 1)}`;
  }

  arr = str.split('=');
  if (arr[0] == ref) return url.substr(0, url.indexOf('?'));
  return url;
};
export const getQueryParam = () => {
  if (!_queryParams || _lastSearch !== window.location.search) {
    _lastSearch = window.location.search;
    _queryParams = parseParam(_lastSearch.substr(1));
  }

  return _queryParams;
};
export const getHashParam = hash => {
  if (!_hashParam || _lastHash !== window.location.hash) {
    _lastHash = window.location.hash;
    _hashParam = parseParam(_lastHash.substr(1));
  }

  if (typeof hash === 'string') return _hashParam[hash];
  return _hashParam;
};
export const toQueryString = obj => {
  const keys = Object.keys(obj);
  let str = '';
  keys.forEach((k, index) => {
    const flg = keys.length - 1 > index ? '&' : '';
    str += `${k}=${obj[k]}${flg}`;
  });
  return str;
};